import { Button, DefaultContent, GrupoEleitoresForm } from '../components';
import { EleicaoResponseType, GrupoEleitoresResponseType } from '../types';
import { FunctionComponent, useEffect, useState } from 'react';
import { useAuthAxios, useErrorHandler, useErrorStatus, useLayout } from '../hooks';
import { useNavigate, useParams } from 'react-router-dom';

import { ApiHelper } from '../helpers';
import { LayoutEnum } from '../enums';
import { Spinner } from '../utils';
import { StatusCodes } from 'http-status-codes';
import { useTranslation } from 'react-i18next';

const GruposEleitoresFormView: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { idEleicao, idGrupoEleitores } = useParams();
  const axios = useAuthAxios();
  const { setErrorStatus } = useErrorStatus();
  const errorHandler = useErrorHandler();
  const [eleicao, setEleicao] = useState<EleicaoResponseType>();
  const [loadingEleicao, setLoadingEleicao] = useState(true);
  const [grupoEleitores, setGrupoEleitores] = useState<GrupoEleitoresResponseType>();
  const [loadingGrupoEleitores, setLoadingGrupoEleitores] = useState(true);
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.BASE_LAYOUT);
  }, []);

  useEffect(() => {
    if (idEleicao) {
      if (ApiHelper.isValidIntegerToApi(idEleicao)) {
        axios
          .get(ApiHelper.getUrl.apiSCE.eleicao(+idEleicao))
          .then((response) => setEleicao(response.data))
          .catch((error) => {
            if (error.response.status === StatusCodes.NOT_FOUND) {
              setErrorStatus(error.response.status);
            } else {
              errorHandler(error, t('erro.recuperar_eleicao'));
            }
          })
          .finally(() => setLoadingEleicao(false));
      } else {
        setTimeout(() => setErrorStatus(StatusCodes.NOT_FOUND));
      }
    }
  }, [idEleicao]);

  useEffect(() => {
    if (idEleicao && idGrupoEleitores) {
      if (ApiHelper.isValidIntegerToApi(idEleicao) && ApiHelper.isValidIntegerToApi(idGrupoEleitores)) {
        axios
          .get(ApiHelper.getUrl.apiSCE.grupoEleitores(+idEleicao, +idGrupoEleitores))
          .then((response) => setGrupoEleitores(response.data))
          .catch((error) => {
            if (error.response.status === StatusCodes.NOT_FOUND) {
              setErrorStatus(error.response.status);
            } else {
              errorHandler(error, t('erro.recuperar_grupo_eleitores'));
            }
          })
          .finally(() => setLoadingGrupoEleitores(false));
      } else {
        setTimeout(() => setErrorStatus(StatusCodes.NOT_FOUND));
      }
    } else {
      setLoadingGrupoEleitores(false);
    }
  }, [idEleicao, idGrupoEleitores]);

  return loadingEleicao || loadingGrupoEleitores ? (
    <Spinner />
  ) : (
    <DefaultContent
      title={t(`label.${grupoEleitores?.id ? 'alterar' : 'cadastrar'}_grupo_eleitores`)}
      subtitle={eleicao?.titulo}
      pageAction={
        <Button title={t('label.voltar')} onClick={() => navigate(`/eleicoes/${idEleicao}/grupos-eleitores/alterar`)} outline />
      }
    >
      <GrupoEleitoresForm idEleicao={eleicao?.id!} grupoEleitores={grupoEleitores} />
    </DefaultContent>
  );
};

export default GruposEleitoresFormView;
